import styled from "styled-components";

export const InfoWrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 700px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0.5em 24px;
    justify-content: center;

    @media screen and (max-width: 780px) {
        height: 1000px;
    }

    @media screen and (max-width: 480px) {
        height: 1400px;
    }
`;

export const InfoRow = styled.div`
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'`)};

    @media screen and (max-width: 768px) {
        grid-template-areas: ${({imgStart}) => (imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`)};
    }
`;

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`;

export const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
`;

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 0;
`;


export const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    color: #fff; 
    font-family: 'DM Sans', sans-serif;

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`;

export const WdHeading = styled.h1`
    margin-bottom: 24px;
    font-size: 38px;
    line-height: 1.1;
    font-weight: 600;
    color: #fff; 
    font-family: sans-serif;

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`;

export const HeadingMw = styled.h1`
    margin-bottom: 24px;
    font-size: 46px;
    line-height: 1.1;
    font-weight: 600;
    color: #fff; 
    font-family: 'Montserrat Subrayada', sans-serif;

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`;

export const Subtitle = styled.p`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 16px;
    line-height: 23px;
    color: #fff; 
    font-family: 'IBM Plex Sans', sans-serif;

    @media screen and (max-width: 905px) {
        font-size: 15px;
    }
`;

export const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const ImgWrap = styled.div`
    max-width: 555px;
    height: 100%;
`;

export const Img = styled.img`
    width: 100%;
    margin: 0 0 10px 0;
    padding-right: 0;
`;


